import AuthService from '../../utilities/services/auth.service'
import { FnbEodReportWrapper } from '../../components'

export default function FnbEodReportPage() {
  const organization = AuthService.getOrg()[0]

  return <FnbEodReportWrapper organization={organization} />
}
